import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * This merges twMerge and clsx into one function. You can get autocomplete
 * and warnings via Tailwind CSS Intellisense by adding `cn` to the
 * `tailwindCSS.classFunctions` array in your VS Code config.
 */
export const cn: typeof clsx = (...classNames) => twMerge(clsx(classNames));
